var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgForecast = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "m11.063 9.563 2.624-2.626M8.063 8.063l1.5 1.5m4.875-2.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm-4.125 4.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm-3-3a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm-.75-.375-3.75 3.75" }), _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M15.75 15.188H2.813V2.25" })] }))); };
export default SvgForecast;
